import { type QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData } from "~/app/api/pageData";
import { configuratorPageQueryOptions } from "~/app/api/pageData/configuratorPageQuery";
import { findConfiguratorRegistration } from "~/bridges/configurator/configuratorRegistry";
import { configuratorConfigurationQueryOptions } from "~/features/configurator-v2/common/data/configuratorConfigurationQuery";

/**
 * Loader-only module for the four LinearConfigurator route files. Kept separate
 * from the component module so the un-split loader reference (main bundle)
 * cannot drag the configurator page tree into the entry chunk.
 */

export async function loadConfiguratorPageData(
  context: { queryClient: QueryClient },
  productCode: string,
  search = "",
) {
  const registration = findConfiguratorRegistration(productCode);
  const configurationPromise =
    registration?.engine === "timeline"
      ? context.queryClient.ensureQueryData(
          configuratorConfigurationQueryOptions(registration.definition.productCode, null),
        )
      : Promise.resolve();
  const [result] = await Promise.all([
    context.queryClient.ensureQueryData(configuratorPageQueryOptions(productCode, search)),
    configurationPromise,
  ]);

  return unwrapPageInitialData(result);
}

export const configuratorRouteLoader = async ({
  context,
  params,
  location,
}: {
  context: { queryClient: QueryClient };
  params: { productCode: string };
  location: { pathname: string; searchStr: string };
}) => loadConfiguratorPageData(context, params.productCode, location.searchStr);
